export default "__VITE_ASSET__CeJPX89h__"